module.exports = __webpack_public_path__ + "static/campfire-a766fb7fa079762d97b7b56649242238.jpg";